<template>
  <div
    class="el-tree-node"
    @click.stop="handleClick(node)"
    :class="{
      'is-expanded': expanded,
      'is-hidden':!node.visible,
      'is-current': currentNode === node,
      'is-selected': !showCheckbox && currentNode && currentNode.id === node.id,
      'is-focusable': !node.disabled,
      'is-checked': !node.disabled && node.checked,
      'is-leaf':isLeaf
    }"
    role="treeitem"
    tabindex="-1"
    :aria-expanded="expanded"
    :aria-disabled="node.disabled"
    :aria-checked="node.checked"
  >
    <div class="el-tree-node__content"
      
      :title="node.label"
      >
      <span
        class="el-tree-node__expand-icon el-icon-caret-right"
        @click.stop="handleExpandIconClick"
        :class="{ 'is-leaf': isLeaf, expanded: !isLeaf && expanded }">
      </span>
      <el-checkbox
        v-if="showCheckbox"
        v-model="node.checked"
        :indeterminate="node.indeterminate"
        :disabled="!!node.disabled"
        @click.native.stop
        @change="handleCheckChange(node,node.checked)"
      >
      </el-checkbox>
      <span
        v-if="node.loading"
        class="el-tree-node__loading-icon el-icon-loading">
      </span>
      <node-content :node="node"></node-content>
    </div>
    <el-collapse-transition>
      <div
        class="el-tree-node__children"
        v-show="expanded"
        role="group"
        :style="{ 'padding-left':indent + 'px' }"
        :aria-expanded="expanded"
      >
        <tree-node
          :render-content="renderContent"
          v-for="(child, idx) in node.children"
          :node="child"
          :level="level+1"
          :indent="indent"
          :current-node="currentNode"
          :show-checkbox="showCheckbox"
          :valueMap="valueMap"
          :default-expand-all="defaultExpandAll"
          :expand-checked="expandChecked"
          :key="idx"
          @visible-change="handleFilter(node)"
          @current-change="handleClick(child)"
          @check-change="checkChange"
          @node-expand="handleChildNodeExpand">
        </tree-node>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>

  export default {
    name: 'TreeNode',
    componentName: 'TreeNode',
    props: {
      node: {
        default() {
          return {};
        }
      },
      valueMap:{},
      filterText:{type:String},
      defaultExpandAll: Boolean,
      indent:{type:Number},
      props: {},
      level:{type:Number},
      currentNode:{},
      showCheckbox: false,
      renderContent: Function,
      expandChecked: {
        type: Boolean,
        default: false
      },
    },

    components: {
      NodeContent: {
        props: {
          node: {
            required: true
          }
        },
        render(h) {
          const parent = this.$parent;
          const node = this.node;
          const data = node.data;
          const store = node.store;
          return (
            parent.renderContent
              ? parent.renderContent.call(parent._renderProxy, h, { _self: parent.tree.$vnode.context, node, data, store })
              : <span class="el-tree-node__label">{ this.node.label }</span>
          );
        }
      }
    },
    computed:{
      isLeaf:{
        get()
        {
          return !this.node.children || this.node.children.length == 0;
        }
      }
    },
    data() {
      return {
        tree: null,
        expanded: this.defaultExpandAll || this.expandChecked&&this.node.indeterminate,
        childNodeRendered: false,
        oldChecked: null,
        oldIndeterminate: null
      };
    },

    watch: {
      'valueMap':{
        handler(val) {
          if (val[this.node.id]&&this.node.checked ==false) {
            this.handleCheckChange(this.node, true);
          }
        },
        deep:true
      },
      'node.expanded'(val) {
        this.$nextTick(() => this.expanded = val);
        if (val) {
          this.childNodeRendered = true;
        }
      }
    },

    methods: {
      handleClick(node) {
        this.$emit('current-change', node);
      },

      handleExpandIconClick() {
        if (this.node.isLeaf) return;
        this.expanded = !this.expanded;
      },
      handleCheckChange(node,checked) {
        node.checked = checked;
        node.indeterminate = false;
        this.$emit('check-change',node);//向上发事件
        //处理子节点
        if(!node.isLeaf) {
          node.children.forEach(v=>{
            if(v.checked!=checked || v.indeterminate==true) {
              this.handleCheckChange(v, checked);
            }
          });
        }
      },
      checkChange(node) {
        var selected = this.node.children.filter(v=>v.checked==true || v.indeterminate==true).length;
        this.node.checked = (this.node.children.filter(v=>v.checked==false).length==0);
        this.node.indeterminate = (selected > 0&&!this.node.checked);

        this.$emit('check-change',node);
      },
      handleChildNodeExpand(nodeData, node, instance) {
        this.broadcast('ElTreeNode', 'tree-node-expand', node);
        //this.tree.$emit('node-expand', nodeData, node, instance);
      }
    },
    mounted() {
      if(this.valueMap[this.node.id]&&this.node.checked ==false) {
        this.handleCheckChange(this.node,true);
      }
    }
  };
</script>

<style scoped>
  .is-hidden { display:none;}
  .el-tree-node{ color:#5a5e66}
  .el-tree-node.is-selected { color:#0072c5;background:#f5f7fa}
</style>
